/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Document_UnavailableInputs */

const en_player_document_unavailable = /** @type {(inputs: Player_Document_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This document isn't available. It may have been deleted or made private.`)
};

const es_player_document_unavailable = /** @type {(inputs: Player_Document_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este documento no está disponible. Es posible que se haya eliminado o que ahora sea privado.`)
};

/**
* | output |
* | --- |
* | "This document isn't available. It may have been deleted or made private." |
*
* @param {Player_Document_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const player_document_unavailable = /** @type {((inputs?: Player_Document_UnavailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Document_UnavailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_player_document_unavailable(inputs)
	return en_player_document_unavailable(inputs)
});